import LanguageList from '../../../component/EliteGame/LanguageList';

const Language = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 m-4">
      <div class="cursor-pointer mb-3 text-[24px] font-bold leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg ">
        Create and Manage Languages
      </div>
      <div className="space-y-4 bg-white p-6 rounded shadow m-4">
        <h2 className="text-xl font-bold text-black-700 mb-4">Create Language</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* 🌍 Language */}
          <div className="w-full sm:flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Language Name <span className="text-red-500">*</span>
            </label>
            <input type="text" placeholder="Language Name" className="input-company w-full" />
          </div>
          <div className="w-full sm:flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Language Code <span className="text-red-500">*</span>
            </label>
            <input type="text" placeholder="Language Code" className="input-company w-full" />
          </div>
        </div>
        <button
          type="submit"
          className="bg-shoorah-active text-white text-sm sm:px-10 py-2 w-full sm:w-auto rounded-full bl</div>ock flex items-center justify-center"
        >
          Submit{' '}
        </button>
      </div>
      <div className="space-y-4 bg-white p-6 rounded shadow m-4">
        <h2 className="text-xl font-bold text-black-700 mb-4">Add Language</h2>

        {/* Flex Row for Select + Button */}
        <div className="w-full sm:w-1/2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Select Language <span className="text-red-500">*</span>
          </label>

          <div className="flex items-center gap-4">
            <select className="input-company flex-1">
              <option value="">Select Language</option>
              <option value="english">English</option>
              {/* Add language options */}
            </select>

            {/* Submit Button aligned with select */}
            <button
              type="submit"
              className="btn-primary"
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <LanguageList />
    </div>
  );
};

export default Language;
